// src/components/Signup/SignupForm.jsx

import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SignupProgress from './SignupProgress';
import PersonalDetailsStep from './PersonalDetailsStep';
import PasswordStep from './PasswordStep';
import SuccessStep from './SuccessStep';
import { cleanupAdminSession } from '../../api/api';

const STEPS = {
  PERSONAL_DETAILS: 1,
  PASSWORD: 2,
  SUCCESS: 3
};

const SignupForm = ({ onCancel }) => {
  const { i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(STEPS.PERSONAL_DETAILS);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    selectedLanguage: i18n.language
  });

  const handleFormDataChange = (newData) => {
    setFormData({
      ...newData,
      selectedLanguage: i18n.language
    });
  };

  const handleNext = () => {
    setCurrentStep(prev => Math.min(prev + 1, 3));
  };

  const handleBack = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const handleCancel = async () => {
    // ✅ Re-enable admin session cleanup
    await cleanupAdminSession();
    
    if (onCancel) {
      onCancel();
    } else {
      window.location.href = '/';
    }
  };

  const handleComplete = () => {
    console.log('Registration completed for:', formData.email);
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case STEPS.PERSONAL_DETAILS:
        return (
          <PersonalDetailsStep
            formData={formData}
            onFormDataChange={handleFormDataChange}
            onNext={handleNext}
            onCancel={handleCancel}
          />
        );
      
      case STEPS.PASSWORD:
        return (
          <PasswordStep
            formData={formData}
            onFormDataChange={handleFormDataChange}
            onNext={handleNext}
            onBack={handleBack}
          />
        );
      
      case STEPS.SUCCESS:
        return (
          <SuccessStep
            formData={formData}
            onComplete={handleComplete}
            onBack={handleBack}
          />
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <SignupProgress currentStep={currentStep} totalSteps={3} />
        <div className="bg-white rounded-lg shadow-sm border p-6 md:p-8">
          {renderCurrentStep()}
        </div>
      </div>
    </div>
  );
};

SignupForm.propTypes = {
  onCancel: PropTypes.func
};

export default SignupForm;